import React, { useCallback } from 'react'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { hooks } from '@front/volcanion'

import { Grid, Box } from '@mui/material'

import Form from './Form'
import Header from './Header'
import Row from './Row'
import Callbacks from './callbacks'

const ExportList = () => {
  const [router_state] = hooks.useRouterState()
  const { user, name } = router_state || {}

  const filterToForm = useCallback(Callbacks.filterToFormHandler(user, name), [user, name])

  return (
    <Grid container justifyContent='center' alignItems='center' sx={{ bgcolor: 'background.primary' }}>
      <Grid size={11}>
        <Box sx={{ p: 2 }}>
          <SearchFrame
            model_name={'task'}
            sort={['createdAt DESC']}
            allowCreate={false}
          >
            <SearchForm
              submitOnMount
              filterToForm={filterToForm}
            >
              <FormContent><Form /></FormContent>
            </SearchForm>
            <SearchTable
              tableProps={{
                onRowClick: undefined
              }}
            >
              <TableHeader><Header /></TableHeader>
              <TableRow><Row /></TableRow>
            </SearchTable>
          </SearchFrame>
        </Box>
      </Grid>
    </Grid>
  );
}

export default React.memo(ExportList)
